import { BaseApiUrl } from '../../../configVariables';
import { CategoryEntity } from '../../../model/CategoryEntity';
import apiClient from '../../../utils/apiClient';

export interface CategoriesResponse {
    search: string;
    items: CategoryEntity[];
    nextPageToken: string;
}

const categoriesBaseUrl: string = `${BaseApiUrl}/appsettings/categories`;

export const fetchCategories = async (
    query: string = ''
): Promise<CategoriesResponse> => {
    const url = `${categoriesBaseUrl}${query}`;
    const result = await apiClient.get<CategoriesResponse>(url);
    return result.data;
};

export const createCategory = async (
    data: CategoryEntity
): Promise<CategoryEntity> => {
    const result = await apiClient.post<CategoryEntity, CategoryEntity>(
        categoriesBaseUrl,
        data
    );
    return result.data;
};

// Use POST for update (upsert) due to firewall restriction on PUT.
export const updateCategory = async (
    data: CategoryEntity
): Promise<CategoryEntity> => {
    const result = await apiClient.post<CategoryEntity, CategoryEntity>(
        categoriesBaseUrl,
        data
    );
    return result.data;
};

export const deleteCategory = async (rowKey: string): Promise<void> => {
    const url = `${categoriesBaseUrl}/${rowKey}`;
    await apiClient.delete(url);
};
